ACC.upcConsents = {

    _autoload: [
        ['setDOBValidation', document.querySelector('.js-user-dob-month-year')],
        ['updateAgeGating', document.querySelector('#dobID')],
    ],

    showUpcMarketingConsents(onDone) {
        const iesUserId = piSession.userId();
        const userToken = piSession.currentToken();
        $.ajax({
            async: false,
            type: 'POST',
            url: `${ACC.config.encodedContextPath}/upcconsents/check`,
            data: {
                iesUserId,
                userToken,
            },
            success: (response) => {
                if (response.showUpcNotificationFragment) {
                    ACC.upcConsents.loadNotificationFragment(
                        iesUserId,
                        userToken,
                        onDone,
                    );
                    return;
                }
                onDone();
            },
            error: () => {
                onDone();
            },
        });
    },

    loadNotificationFragment(iesUserId, userToken, onDone) {
        $('#mainPageContent').load(`${ACC.config.encodedContextPath}/upcconsents`, () => {
            if (ACC.utils.isHedTheme()) {
                ACC.utils.addClassToBodyTag('page-upc-consents');
            }

            $('.js-upc-consent-btn').on('click', (e) => {
                e.preventDefault();
                const preferenceValue = $('#preferenceValue').prop('checked');
                ACC.upcConsents.sendUpcConsents(preferenceValue, iesUserId, userToken, onDone);
            });
        });
    },

    sendUpcConsents(preferenceValue, customerUid, token, onDone) {
        $.ajax({
            type: 'POST',
            headers: {
                'Content-Type': 'application/json',
                CSRFToken: ACC.config.CSRFToken,
            },
            url: `${ACC.config.encodedContextPath}/upcconsents/send`,
            data: JSON.stringify([{
                customerUid,
                preferenceItemId: ACC.config.thirdPartyMarketingPreferenceId,
                preferenceValue,
                countryCode: ACC.config.gcpCountryCode,
                token,
            }, {
                customerUid,
                preferenceItemId: ACC.config.marketingConsentGlobalPreferenceId,
                preferenceValue,
                countryCode: ACC.config.gcpCountryCode,
                token,
            }, {
                customerUid,
                preferenceItemId: ACC.config.userProfilePreferenceId,
                preferenceValue: ACC.config.userProfileAutoAgree,
                countryCode: ACC.config.gcpCountryCode,
                token,
            }]),
            success: () => {
                onDone();
            },
            error: () => {
                onDone();
            },
        });
    },

    getPiSessionToken: () => {
        let currentToken;
        piSession.getToken((status, token) => {
            currentToken = token;
        });
        return currentToken;
    },

    setDOBValidation() {
        const dobMonth = document.querySelector('#dobMonthID');
        const dobYear = document.querySelector('#dobYearID');
        const inputDOB = document.querySelector('#dobID');
        let selectedMonth;
        let selectedYear;

        if (dobMonth.value && dobYear.value) {
            selectedMonth = `0${dobMonth.selectedIndex}`.slice(-2);
            selectedYear = dobYear.value;
            inputDOB.value = `${selectedMonth}-${selectedYear}`;
        }

        [dobMonth, dobYear].map((element) => element.addEventListener(
            'change',
            (event) => ACC.upcConsents.setAndValidateDOB(event, element, selectedMonth, selectedYear, inputDOB),
        ));
        [dobMonth, dobYear].map((element) => element.addEventListener('focusout', () => {
            $('#dobID').valid();
        }));
    },

    setAndValidateDOB(event, element, selectedMonth, selectedYear, inputDOB) {
        switch (event.target.id) {
        case 'dobMonthID':
            selectedMonth = `0${element.selectedIndex}`.slice(-2);
            inputDOB.value = `${selectedMonth}${inputDOB.value ? inputDOB.value.slice(2) : ''}`;
            break;
        case 'dobYearID':
            selectedYear = event.target.value;
            inputDOB.value = `${inputDOB.value ? inputDOB.value.slice(0, 2) : ''}-${selectedYear}`;
            break;
        default:
            return;
        }

        $('#dobID').valid();
    },

    updateAgeGating() {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;

        const minorMessage = document.querySelector('#minor-message');
        const dobMonthID = document.querySelector('#dobMonthID');
        const dobYearID = document.querySelector('#dobYearID');
        const dobID = document.querySelector('#dobID');
        const { ageGatingYearsLimit } = ACC.config;

        ACC.upcConsents.setMinorMessage(currentYear, currentMonth, minorMessage, ageGatingYearsLimit, dobID);
        [dobMonthID, dobYearID].forEach((elem) => {
            elem.addEventListener(
                'change',
                () => ACC.upcConsents.setMinorMessage(
                    currentYear,
                    currentMonth,
                    minorMessage,
                    ageGatingYearsLimit,
                    dobID,
                ),
            );
        });
    },

    setMinorMessage(currentYear, currentMonth, minorMessage, ageGatingYearsLimit, dobID) {
        if (/^(0[1-9]|(1[0-2]))-((19[0-9]{2})|(20[0-9]{2}))$/.test(dobID.value)) {
            const [monthOfBirth, yearOfBirth] = dobID.value.split('-');
            const amountOfYears = currentYear - yearOfBirth;

            if (amountOfYears < +ageGatingYearsLimit
                || (amountOfYears === +ageGatingYearsLimit && currentMonth <= monthOfBirth)) {
                minorMessage.classList.remove('hidden');
            } else {
                minorMessage.classList.add('hidden');
            }
        } else {
            minorMessage.classList.add('hidden');
        }
    },
};
